export enum UserRoleType {
  Admin = 'Admin',
  Manager = 'Manager',
  Technician = 'Technician',
}
